import { arrayOf, string } from 'prop-types';
import React from 'react';

const ColorThemeImageContainer = ({ mainImage, images = [], themeType, colorCode }) => {
	const defaultImage = `${process.env.PUBLIC_URL}/images/trend/demo-dress.png`;
	const filledImages = [...images, ...Array(Math.max(0, 2 - images.length)).fill(defaultImage)].slice(0, 2);

	return (
		<div className="product-img-container">
			{themeType === 'COLOR' && (
				<div className="prev-img key-solid-color">
					<div className="w-100 h-100" style={{ background: colorCode }}></div>
				</div>
			)}
			{themeType !== 'COLOR' && (
				<div className="prev-img">
					<img src={mainImage || defaultImage} alt="" />
				</div>
			)}
			<div className="prev-img-thumb">
				{filledImages.map((img, index) => (
					<div key={index} className={`single-${['first', 'second', 'third', 'fourth'][index]}`}>
						<img src={img} alt={`Thumbnail ${index + 1}`} />
					</div>
				))}
			</div>
		</div>
	);
};

ColorThemeImageContainer.propTypes = {
	mainImage: string.isRequired,
	themeType: string.isRequired,
	images: arrayOf(string).isRequired
};

export default ColorThemeImageContainer;
